import Grid from "@mui/material/Grid";
import React from "react";
import {styled} from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import AttributeNSC from "./AttributeNSC";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));

export default function AttributesNSC() {

    return <Grid container style={{paddingTop: 4, paddingBottom: 4, alignItems: "stretch"}}
                 spacing={1}>
        <Grid item xs={6} sm={4}>
            <Item>
                <AttributeNSC attribute={'ges'}/>
            </Item>
        </Grid>
        <Grid item xs={6} sm={4}>
            <Item>
                <AttributeNSC attribute={'str'}/>
            </Item>
        </Grid>
        <Grid item xs={6} sm={4}>
            <Item>
                <AttributeNSC attribute={'zae'}/>
            </Item>
        </Grid>
        <Grid item xs={6} sm={4}>
            <Item>
                <AttributeNSC attribute={'wah'}/>
            </Item>
        </Grid>
        <Grid item xs={6} sm={4}>
            <Item>
                <AttributeNSC attribute={'wil'}/>
            </Item>
        </Grid>
        <Grid item xs={6} sm={4}>
            <Item>
                <AttributeNSC attribute={'cha'}/>
            </Item>
        </Grid>
    </Grid>
}